import styled from 'styled-components';

const ChartArea = styled.div`
  margin-bottom: 2rem;
`;

export default ChartArea;
